module.exports = __webpack_public_path__ + "static/media/cowled.d0cad9db.svg";